<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { barChart } from "./data-overview";
import DetailsCard from "./components/DetailsCard";
import MemberCard from "./components/MemberCard";
import FilesCard from "./components/FilesCard";
import CommentsCard from "./components/CommentsCard";


/**
 * Projects-overview component
 */
export default {
  page: {
    title: "Projects Overview",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {CommentsCard, FilesCard, MemberCard, DetailsCard, Layout, PageHeader, },
  data() {
    return {
      barChart: barChart,
      title: "Projects Overview",
      items: [
        {
          text: "Projects",
          href: "/"
        },
        {
          text: "Projects Overview",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-8">
       <DetailsCard />
      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <MemberCard />
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Overview</h4>

            <div id="overview-chart" class="apex-charts" dir="ltr"></div>
            <apexchart
                class="apex-charts"
                type="bar"
                height="280"
                :series="barChart.series"
                :options="barChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <FilesCard />
      </div>
      <!-- end col -->

      <div class="col-lg-4">
      <CommentsCard />
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
